import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { getSuperstoreValue, localSuperstoreKeys, setSuperstoreValue } from '../utils/localSuperstore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { DISTANCE_MEASUREMENT_MEDIUM } from 'HubStyleTokens/sizes';
import { logError } from 'calling-error-reporting/report/error';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFeedback = styled.div.withConfig({
  displayName: "Feedback__StyledFeedback",
  componentId: "sc-1cpl2xz-0"
})(["padding-top:", ";opacity:", ";max-height:", ";transition:opacity 0.3s 0s,max-height 0.5s 0s,padding-top 0.3s 0s;"], ({
  showFeedback
}) => showFeedback ? DISTANCE_MEASUREMENT_MEDIUM : 0, ({
  showFeedback
}) => showFeedback ? 1 : 0, ({
  showFeedback
}) => showFeedback ? '80px' : '0');
const Feedback = ({
  callId,
  usageTracker
}) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const [showFeedbackConfirmation, setShowFeedbackConfirmation] = useState(false);
  const feedbackTimeout = useRef();
  useEffect(() => {
    getSuperstoreValue(localSuperstoreKeys.CALL_SUMMARY_FEEDBACK).then(feedbackEntries => {
      setShowFeedback(!(feedbackEntries || []).includes(callId));
    }).catch(error => {
      logError({
        error
      });
    });
  }, [callId]);
  useEffect(() => {
    return () => {
      if (feedbackTimeout.current) {
        clearTimeout(feedbackTimeout.current);
      }
    };
  }, []);
  const provideFeedback = value => {
    usageTracker.track('callSummaryFeedback', {
      isUseful: value
    });
    getSuperstoreValue(localSuperstoreKeys.CALL_SUMMARY_FEEDBACK).then(feedbackEntries => {
      const updatedFeedbackEntries = (feedbackEntries || []).push(callId);
      setSuperstoreValue(localSuperstoreKeys.CALL_SUMMARY_FEEDBACK, updatedFeedbackEntries).catch(error => {
        logError({
          error
        });
      });
    }).catch(error => {
      logError({
        error
      });
    });
    setShowFeedbackConfirmation(true);
    feedbackTimeout.current = setTimeout(() => setShowFeedback(false), 2000);
  };
  const renderContent = () => {
    if (showFeedbackConfirmation) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "call-summary.feedback.confirmation"
      });
    }
    if (showFeedback) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "call-summary.feedback.question_jsx",
        elements: {
          UILink
        },
        options: {
          yes: {
            onClick: () => provideFeedback(true)
          },
          no: {
            onClick: () => provideFeedback(false)
          }
        }
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsx(StyledFeedback, {
    showFeedback: showFeedback,
    children: renderContent()
  });
};
export default Feedback;